import request from '@/util/request';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/call/record/page', Object.assign({}, options, { params }));

// 更新通话记录
export const updateRecordApi = (params, options) =>
  request.post('/api/v4ward/callcenter/call/record/updateOrderNo', params, options);